import { getRefundInfo } from '../RefundPill/refundInfo'

export const RESOLVE_NOTE =
  'Primero se revisa en Mercado Pago: si ya lo devolviste desde su panel, sólo se cierra la transacción; si no, se le pide la devolución.'

const RESOLVED_MESSAGES = {
  synced: 'Mercado Pago ya lo había devuelto. Se cerró la transacción.',
  refunded: 'Mercado Pago hizo la devolución y se cerró la transacción.'
}

const PROCESSING_MESSAGE =
  'Mercado Pago todavía no confirma la devolución. Queda en proceso: la recuperación lo revisa sola y avisa a pagos si no sale.'

const STILL_MANUAL = 'Sigue para resolver a mano.'

const OTHER_AMOUNT = `Mercado Pago muestra una devolución por otro monto. Revisalo en Mercado Pago. ${STILL_MANUAL}`

const REVIEW_MESSAGES = {
  not_fully_refunded: OTHER_AMOUNT,
  amount_mismatch: OTHER_AMOUNT,
  expected_amount_unknown: OTHER_AMOUNT,
  unexpected_provider_status: `Mercado Pago muestra el pago en un estado inesperado. Revisalo en Mercado Pago. ${STILL_MANUAL}`,
  not_cancelled: `Es un pago autorizado y Mercado Pago no lo muestra cancelado. Revisalo en Mercado Pago. ${STILL_MANUAL}`,
  provider_unavailable: 'No se pudo consultar Mercado Pago. Probá de nuevo en un rato.',
  seat_unknown: 'No se pudo revisar si el pasajero está en un viaje. Probá de nuevo en un rato.',
  amount_unknown:
    'No se sabe cuánto devolver (por ejemplo, porque entró otro cobro). Devolvelo desde Mercado Pago y volvé a tocar Resolver para cerrarlo.',
  alternative_payment: 'Es un pago por transferencia o depósito: se devuelve a mano.',
  missing_payment: `La transacción no tiene un pago de Mercado Pago. ${STILL_MANUAL}`,
  invalid_currency: `La transacción no tiene una moneda válida. ${STILL_MANUAL}`,
  unexpected_status: 'La transacción ya no figura cobrada. Recargá para ver cómo quedó.',
  test_token: 'En el entorno de prueba no se consulta Mercado Pago.'
}

export const isManualRefund = info => info?.state === 'manual' && info.method === 'original'

export const resolveProblemMessage = (code, detail = {}) => {
  switch (code) {
    case 'insufficient_funds':
      return 'La cuenta de Mercado Pago no tiene saldo disponible para devolverlo. Sigue para resolver a mano: probá de nuevo cuando haya saldo.'
    case 'refund_failed':
      return detail.message
        ? `Mercado Pago rechazó la devolución: ${detail.message}. ${STILL_MANUAL}`
        : `Mercado Pago rechazó la devolución. ${STILL_MANUAL}`
    case 'needs_review':
      return REVIEW_MESSAGES[detail.reason] || `No se pudo resolver solo. Revisalo en Mercado Pago. ${STILL_MANUAL}`
    case 'companion_in_lobby':
      return `El pasajero figura en un viaje con este pago, así que no se devolvió. Revisá si todavía corresponde. ${STILL_MANUAL}`
    case 'already_refunding':
    case 'not_manual':
      return 'Ya no está para resolver a mano: otro proceso lo tomó o ya terminó. Recargá para ver cómo quedó.'
    case 'refunds_paused':
      return 'Los reembolsos automáticos están en pausa. Resolvelo a mano.'
    case 'not_found':
      return 'No existe una transacción con ese ID.'
    default:
      return 'No se pudo resolver. Probá de nuevo en un rato.'
  }
}

export const resolveOutcome = ({ ok, status, data }) => {
  if (status === 202) return { done: true, severity: 'info', message: PROCESSING_MESSAGE, update: {} }
  if (ok) {
    return {
      done: true,
      severity: 'success',
      message: RESOLVED_MESSAGES[data?.result] || RESOLVED_MESSAGES.refunded,
      update: { status: data?.status, refund: data?.refund }
    }
  }
  const code = data?.code || (status === 404 ? 'not_found' : null)
  return { done: false, severity: 'error', message: resolveProblemMessage(code, data || {}) }
}

export const refundAfterResolve = (update, transaction) => {
  if (update?.refund) return update.refund
  if (transaction?.refund && typeof transaction.refund === 'object') {
    return { ...transaction.refund, state: 'processing' }
  }
  const info = getRefundInfo(transaction)
  return {
    method: 'original',
    state: 'processing',
    amount: info?.amount ?? null,
    currency: info?.currency ?? null,
    refund_reason: info?.reason ?? null
  }
}
